module.exports = __webpack_public_path__ + "img/logo-rentik.6de44618.svg";